import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SubBrand, SubBrandPayload } from '../domains/domain.model';

const BASE = environment.contractUrl;

/** CRUD for the global SUB_BRANDS table. */
@Injectable({ providedIn: 'root' })
export class SubBrandService {
  private readonly http = inject(HttpClient);

  listSubBrands(): Observable<SubBrand[]> {
    return this.http.get<SubBrand[]>(`${BASE}/subbrands`);
  }

  getSubBrand(id: number): Observable<SubBrand> {
    return this.http.get<SubBrand>(`${BASE}/subbrands/${id}`);
  }

  createSubBrand(body: SubBrandPayload): Observable<SubBrand> {
    return this.http.post<SubBrand>(`${BASE}/subbrands`, body);
  }

  updateSubBrand(id: number, body: SubBrandPayload): Observable<SubBrand> {
    return this.http.put<SubBrand>(`${BASE}/subbrands/${id}`, body);
  }

  deleteSubBrand(id: number): Observable<void> {
    return this.http.delete<void>(`${BASE}/subbrands/${id}`);
  }
}
